import { sounds } from "./constants";
import { sharedData } from "./sharedData";

export const getWidth = (list, gameRef, child) => {
	let width = 0;
	child.style.display = "none";
	const { clientWidth, clientHeight } = gameRef?.current || {};
	child.style.display = "block";

	if (clientWidth > clientHeight) {
		width = clientHeight / (list.length || 1) - 20;
	} else {
		width = clientWidth / (list.length || 1);
	}

	return width;
};

export const playSound = () => {
	if (sounds.backgroundPlay.playing()) {
		sounds.settingsSound.play();
	}
};

export const showAdvAfterRound = (betweenTime = 120000) =>
	new Promise((resolve) => {
		if (window.sdk?.adv) {
			if (Date.now() - sharedData.lastRewordTime > betweenTime) {
				window.sdk.adv.showFullscreenAdv({
					callbacks: {
						onOpen: () => {
							if (sounds.backgroundPlay.playing()) {
								sounds.backgroundPlay.stop();
							}
						},
						onClose: () => {
							sharedData.lastRewordTime = Date.now();
							resolve(true);

							if (
								window.localStorage.getItem("soundOn") !== "false" &&
								!sounds.backgroundPlay.playing()
							) {
								sounds.backgroundPlay.play();
							}
						},
						onError: () => {
							resolve(true);
							if (
								window.localStorage.getItem("soundOn") !== "false" &&
								!sounds.backgroundPlay.playing()
							) {
								sounds.backgroundPlay.play();
							}
						},
					},
				});
			} else {
				resolve(true);
			}
		} else {
			resolve(true);
		}
	});

export const openRewardedVideo = ({
	openCallback = () => {},
	onRewarded = () => {},
	closeCallback = () => {},
	errorCallback = () => {},
}) => {
	if (window.sdk?.adv) {
		window.sdk.adv.showRewardedVideo({
			callbacks: {
				onOpen: () => {
					openCallback();
					if (sounds.backgroundPlay.playing()) {
						sounds.backgroundPlay.stop();
					}
				},
				onRewarded,
				onClose: () => {
					closeCallback();
					if (window.localStorage.getItem("soundOn") !== "false" && !sounds.backgroundPlay.playing()) {
						sounds.backgroundPlay.play();
					}
				},
				onError: () => {
					errorCallback();
					if (window.localStorage.getItem("soundOn") !== "false" && !sounds.backgroundPlay.playing()) {
						sounds.backgroundPlay.play();
					}
				},
			},
		});
	}
};
